import type { Order } from "@graphql/generated/components";
import type { IPaymentStrategy } from "@interfaces/payment-method/PaymentStrategy";
import type { PaymentValues } from "@lib/utils/checkoutHelper";
import { getReadablePaymentMethod, getSuccessPayment, logError } from "./amazonPaymentMethodUtils";

export class AmazonDefaultStrategy implements IPaymentStrategy {
    resolve(order: Order): PaymentValues {
        const payment = getSuccessPayment(order);

        if (!payment) {
            logError("PAYMENT: Payment not found", order?.cart?.id);
            return {
                paymentSystem: null,
                paymentSystemIcon: null,
                paymentReference: null,
                paymentDateOfExpiry: null,
            };
        }

        const paymentSystem = payment?.paymentMethodInfo?.method
            ? getReadablePaymentMethod(payment?.paymentMethodInfo?.method)
            : null;

        return {
            paymentSystem: paymentSystem,
            paymentSystemIcon: null,
            paymentReference: null,
            paymentDateOfExpiry: null,
        };
    }
}
